<template>
    <div class="container">
        <b-modal :model-value="modEditarTipoMoneda" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} 
            </div>
            <div>
                <!-- <pre>{{ infoTipoMoneda[0] }}</pre> -->
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h5>{{ infoTipoMoneda[0]?.moneda }}</h5> 
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" :items="infoTipoMoneda[0]?.descripcion" class="form-control"> 
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.acronimo}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" :items="infoTipoMoneda[0]?.acronimo" class="form-control"> 
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-col cols="7" class="text-left">
                        <b-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</b-button> 
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <b-button class="md-primary" @click="guardarTipoMoneda">{{ labels.save }}</b-button> 
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
                    </b-col>
                </div>
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="deleteTipoMoneda" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"></InacticaItem>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda'; 
import InacticaItem from '../../utils/InacticaItem.vue'; 

export default {
    name : 'Editar',
    props: ['modEditarTipoMoneda','infoTipoMoneda'],
    components:{InacticaItem},
    data: () => ({
        deleteTipoMoneda : false,
        idTipoMoneda : null
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear tipo moneda',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    acronimo : 'Acrónimo',
                    save : 'Guardar',
                    close : 'Cerrar',
                    delete : 'Eliminar'
                }
            }else{
                return {
                    title : 'Create currency type',
                    codigo : 'Code',
                    descripcion : 'Description',
                    acronimo : 'Acronym',
                    save : 'Save',
                    close : 'Close',
                    delete : 'Delete'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        cierraModalDelet(){
            this.deleteTipoMoneda = false 
        },
        guardarTipoMoneda(){
            const dataForm = [
                this.infoTipoMoneda[0].moneda, 
                this.infoTipoMoneda[0].descripcion, 
                this.infoTipoMoneda[0].acronimo 
            ]

            if(dataForm.includes('')){ 
                this.$toast.error('Campo(s) pendiente(s) por diligenciar') 
            }else{
                let info = {
                    'id' : this.infoTipoMoneda[0].id, 
                    'descripcion' : this.infoTipoMoneda[0].descripcion, 
                    'acronimo' : this.infoTipoMoneda[0].acronimo, 
                    'idUser' : this.$store.state.userId 
                }   
                // console.log(info); 
                TipoMoneda.updateTipoMonedaById(info) 
                .then((res) => { 
                    if(res.status == 200){ 
                        this.$toast.success(res.data?.message || 'Tipo moneda actualizado correctamente') 
                        setTimeout(() => location.reload(), 800) 
                    
                    }else if(res.status == 204){ 
                        this.$toast.error('Tipo moneda ya existe.') 
                        return
                    }else{
                        this.$toast.error(res.data?.message || 'No fue posible actualizar el tipo moneda') 
                    }
                })
                .catch((err) => { 
                    console.log(err) 
                    this.$toast.error('Ocurrió un error al actualizar el tipo moneda') 
                }) 
            }
        },
        eliminaRegistro(){
            this.idTipoMoneda = this.infoTipoMoneda[0].id 
            this.deleteTipoMoneda = true 
        },
        confirmInactivate(){
            TipoMoneda.deleteTipoMoneda(this.idTipoMoneda) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data?.message || 'Tipo moneda eliminado correctamente') 
                    setTimeout(() => location.reload(), 800) 
                }else{
                    this.$toast.error(res.data?.message || 'No fue posible eliminar el tipo moneda') 
                }
            })
            .catch((error) => {
                console.log(error) 
                this.$toast.error('Ocurrió un error al eliminar el tipo moneda') 
            }) 
        }
    }
}
</script>

<style>

</style>
